module.exports = __webpack_public_path__ + "static/media/orbital_logo.269d73a8.png";